module.exports = __webpack_public_path__ + "media/img/pages/companies/etat-de-genève-c2d284a2e821d2086f2f6d2bfa064c91.webp";